export default {
  sessionKey: {
    key: "",
    timeout: ""
  },
  room: {},
  formInfo: {},
  singleDayPrice: null
};
